export const TOKEN = "token";

export const add = (key, value) => localStorage.setItem(key, value);
export const remove = (key) => localStorage.removeItem(key);
export const get = (key) => localStorage.getItem(key);
export const clearAll = () => localStorage.clear();
